import Vue from "vue"
import axios from "axios"
import VueAxios from "vue-axios"
import JwtService from "@/core/services/jwt.service"
import store from "@/core/services/store"
import router from "@/router.js"
import { LOGOUT } from "@/core/services/store/auth.module"

/**
 * Service to call HTTP request via Axios
 */

const env = process.env

const handleRequestError = (error) => {
  const response = error && error.response;

  if (response && response.status == 401) {
    store.dispatch(LOGOUT);
    if (router.currentRoute.name !== "login") {
      router.push({ name: "login" }).catch(() => {});
    }
  }

  return Promise.reject(error);
};

const ApiService = {
  bridge: null,

  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = env.VUE_APP_API_ENDPOINT;
    Vue.axios.interceptors.response.use(
      (response) => response,
      (error) => handleRequestError(error)
    );
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;

    this.bridge = axios.create({
      baseURL: process.env.VUE_APP_API_SATUSEHAT_ENDPOINT
    });
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(handleRequestError);
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    return Vue.axios.get(`${resource}${slug}`).catch(handleRequestError);
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params).catch(handleRequestError);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @returns {Promise<any>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}${slug}`, params).catch(handleRequestError);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {Promise<any>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params).catch(handleRequestError);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(handleRequestError);
  }
};

export default ApiService;
